import clsx from 'clsx';
import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import FancyTitle from '../fancy-title';
import Container from '../Container';

export default function Headlines({ blok }) {
  const styles = clsx('blok-headlines ');

  let headlineLevel = blok.headline_level ? blok.headline_level.toLowerCase() : 'h3';
  if (headlineLevel.startsWith('h') === false) {
    headlineLevel = `h${headlineLevel}`;
  }
  const topHeadline = headlineLevel === 'h3' || headlineLevel === 'h2';

  const Wrapper = blok.use_container ? Container : React.Fragment;

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <Wrapper>
        <FancyTitle
          text={blok.headline}
          className={`${blok.text_align} ${topHeadline && 'mb-20'}`}
          tag={headlineLevel}
          subtitle={blok.subline}
          // textAlign={`${blok.text_align || 'text-center'}`}
          marginBottom="0"
        />
      </Wrapper>
    </div>
  );
}
